import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { GeneralPropertyTabComponent } from "./genericNodePropertyComponent";
import { LineContainerComponent } from "shared-ui-components/lines/lineContainerComponent";
import { FileButtonLine } from "shared-ui-components/lines/fileButtonLineComponent";
import { CheckBoxLineComponent } from "../../sharedComponents/checkBoxLineComponent";
import { ButtonLineComponent } from "shared-ui-components/lines/buttonLineComponent";
export class TextureSourcePropertyTabComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    async _prepareImgToLoadAsync(url) {
        return await new Promise((resolve, reject) => {
            const img = new Image();
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            img.onload = () => {
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL());
            };
            img.onerror = () => {
                reject(new Error("Failed to load image"));
            };
            img.src = url;
        });
    }
    async loadTextureFromFileAsync(imageFile) {
        return await this._prepareImgToLoadAsync(URL.createObjectURL(imageFile));
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    async loadTextureData(file) {
        const block = this.props.nodeData.data;
        block.textureDataUrl = await this.loadTextureFromFileAsync(file);
        this.props.stateManager.onRebuildRequiredObservable.notifyObservers();
        this.props.stateManager.onUpdateRequiredObservable.notifyObservers(block);
    }
    removeData() {
        const block = this.props.nodeData.data;
        block.textureDataUrl = "";
        this.forceUpdate();
        this.props.stateManager.onUpdateRequiredObservable.notifyObservers(block);
        this.props.stateManager.onRebuildRequiredObservable.notifyObservers();
    }
    render() {
        const block = this.props.nodeData.data;
        return (_jsxs("div", { children: [_jsx(GeneralPropertyTabComponent, { stateManager: this.props.stateManager, nodeData: this.props.nodeData }), _jsxs(LineContainerComponent, { title: "PROPERTIES", children: [_jsx(FileButtonLine, { label: "Load", onClick: async (file) => await this.loadTextureData(file), accept: ".jpg, .png, .tga, .exr" }), block.textureDataUrl && _jsx(ButtonLineComponent, { label: "Remove", onClick: () => this.removeData() })] }), _jsxs(LineContainerComponent, { title: "ADVANCED", children: [_jsx(CheckBoxLineComponent, { label: "Serialized cached data", target: block, propertyName: "serializedCachedData", onValueChanged: () => {
                                this.props.stateManager.onRebuildRequiredObservable.notifyObservers();
                            } }), _jsx(CheckBoxLineComponent, { label: "Invert Y", target: block, propertyName: "invertY", onValueChanged: () => {
                                this.props.stateManager.onRebuildRequiredObservable.notifyObservers();
                            } })] })] }));
    }
}
//# sourceMappingURL=textureSourceNodePropertyComponent.js.map